export default "__VITE_ASSET__UxEC8uUJ__"